import { Box, Flex, Heading, SimpleGrid } from "@chakra-ui/react";
import { getNftId } from "@umami/chains";
import { useDynamicDrawerContext } from "@umami/components";
import { BigNumber } from "bignumber.js";
import { range } from "lodash";

import { NFTCard } from "./NFTCard";
import { NFTDrawer } from "./NFTDrawer";
import { NFTFilter, useNFTFilter } from "./NFTFilter";
import { EmptyMessage } from "../../components/EmptyMessage";
import { ViewOverlay } from "../../components/ViewOverlay/ViewOverlay";
import { useColor } from "../../styles/useColor";

import { trackButtonClick } from "@/utils/analytics";

export const NFTs = () => {
  const color = useColor();
  const { openWith } = useDynamicDrawerContext();
  const { nfts, options: nftFilterOptions, getCheckboxProps, selected } = useNFTFilter();
  const totalCount = nfts.reduce((acc, nft) => acc.plus(nft.balance), BigNumber(0)).toNumber();

  const gridTemplateColumns = {
    base: "repeat(auto-fit, minmax(min(100%/2, max(157px, 100%/5)), 1fr))",
    md: "repeat(auto-fit, minmax(min(100%/2, max(236px, 100%/5)), 1fr))",
  };

  return (
    <>
      <Flex
        zIndex={1}
        flexDirection="column"
        flexGrow={1}
        gap={{ base: "12px", md: "30px" }}
        padding={{
          md: "10px",
          base: "8px",
        }}
      >
        {nfts.length ? (
          <>
            <Flex alignItems="flex-start" justifyContent="space-between">
              <NFTFilter
                getCheckboxProps={getCheckboxProps}
                options={nftFilterOptions}
                selected={selected}
              />
              <Flex alignItems="center" height="30px">
                <Heading color={color("600")} data-testid="total-count" size="sm">
                  {totalCount}
                </Heading>
              </Flex>
            </Flex>
            <SimpleGrid
              gridTemplateColumns={gridTemplateColumns}
              spacingX="12px"
              spacingY={{ base: "18px", md: "30px" }}
            >
              {nfts.map(nft => (
                <NFTCard
                  key={getNftId(nft)}
                  nft={nft}
                  onClick={() => openWith(<NFTDrawer nft={nft} />)}
                />
              ))}
              {/* empty boxes to make up to a full row */}
              {range(4 - (nfts.length % 4)).map(index => (
                <Box key={index} />
              ))}
            </SimpleGrid>
          </>
        ) : (
          <EmptyMessage
            margin="auto"
            cta="Buy your first NFT"
            ctaUrl="https://objkt.com/"
            onClick={() => {
              trackButtonClick("buy_nft", {
                button_label: "Buy your first NFT",
                section: "dashboard",
                flow: "buy nft",
                action: "button_click",
              });
            }}
            subtitle={"Explore and purchase unique digital assets\n to start your collection."}
            title="Browse NFTs"
          />
        )}
      </Flex>
      {!nfts.length && <ViewOverlay iconType="nfts" />}
    </>
  );
};
